// src/games.js
import Stacks from './game/Stacks.js';
import Stairs from './game/Stairs.js';
import CrossyRoad from './game/CrossyRoad.js';
import DuckHunt from './game/DuckHunt.js';
import SpacePirates from './game/space_pirates/SpacePirates.js';
import CarTest from './game/carmagedon/CarTest.js';
import Carmagedon from './game/carmagedon/Carmagedon.js';
// Hidden from the public arcade for now.
// import MidiPlayer from './game/midi_player/MidiPlayer.js';
// import SumoSpheres from './game/sumo_spheres/SumoSpheres.js';


export const games = [
    {
        id: 'stacks',
        name: 'Stacks',
        description: 'A minimalist game about stacking blocks perfectly.',
        image: 'assets/thumb_stacks.png',
        gameClass: Stacks,
    },
    {
        id: 'stairs',
        name: 'Stairs',
        description: 'Build a staircase to the sky, one step at a time.',
        image: 'assets/thumb_stairs.png',
        gameClass: Stairs,
    },
    {
        id: 'crossyroad',
        name: 'Crossy Road',
        description: 'A classic frogger-style game with a modern twist.',
        image: 'assets/thumb_crossyroad.png',
        gameClass: CrossyRoad,
    },
    {
        id: 'duckhunt',
        name: 'Pigeon Hunt',
        description: 'Shoot pigeon with your trusty shotgun.',
        image: 'assets/thumb_pidgeonHunt.png',
        gameClass: DuckHunt,
    },
    {
        id: 'spacepirates',
        name: 'Space Rush',
        description: 'High speed racing trough endless space.',
        image: 'assets/thumb_spaceRush.png',
        gameClass: SpacePirates,
    },
    {
        id: 'carmagedon',
        name: 'Zombie Delivery',
        description: 'Deliver packages while being chased by zombies.',
        image: 'assets/thumb_carmagedon.png',
        gameClass: Carmagedon,
    },
];
